import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DashboardPage from "./DashboardPage";
import RulesPage from "./RulesPage";
import TemplatesPage from "./TemplatesPage";
import BlocklistsPage from "./BlocklistsPage";
import SettingsPage from "./SettingsPage";
import { Routes, Route, Navigate } from "react-router-dom";

export default function HomePage() {
	return (
		<div className="w-full min-h-screen bg-white flex flex-col">
			<Header />
			<div className="flex flex-1 min-h-[480px]">
				<Sidebar />
				<main className="flex-1 p-6">
					<Routes>
						<Route path="dashboard" element={<DashboardPage />} />
						<Route path="rules" element={<RulesPage />} />
						<Route path="templates" element={<TemplatesPage />} />
						<Route path="block-lists" element={<BlocklistsPage />} />
						<Route path="" element={<Navigate to="dashboard" />} />
						<Route path="settings" element={<SettingsPage />} />
					</Routes>
				</main>
			</div>
		</div>
	);
}
